module.exports = __webpack_public_path__ + "static/media/undraw_meditation_re_gll0.d139afef.svg";